import { render, staticRenderFns } from "./DialogAddItem.vue?vue&type=template&id=5b4f7169"
import script from "./DialogAddItem.vue?vue&type=script&lang=js"
export * from "./DialogAddItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports